import { render, staticRenderFns } from "./Posts.vue?vue&type=template&id=5facec5c"
import script from "./Posts.vue?vue&type=script&lang=js"
export * from "./Posts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5facec5c')) {
      api.createRecord('5facec5c', component.options)
    } else {
      api.reload('5facec5c', component.options)
    }
    module.hot.accept("./Posts.vue?vue&type=template&id=5facec5c", function () {
      api.rerender('5facec5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/section/Posts.vue"
export default component.exports